var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/edit.bc9f0006.png","uri@2x": __webpack_public_path__ + "static/media/edit.ed499a3e.png","uri@3x": __webpack_public_path__ + "static/media/edit.691c5db4.png",
    width: 21,
    height: 21
});